// src/redux/slices/webinarsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { webinarsService } from '../../services/webinarsService.js'
import { handleApiError } from '../../utils/handleApiError.js'

export const fetchWebinars = createAsyncThunk(
    'webinars/fetchWebinars',
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await webinarsService.getWebinars(params)
            return response
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

export const fetchWebinarBySlug = createAsyncThunk(
    'webinars/fetchWebinarBySlug',
    async (slug, { rejectWithValue }) => {
        try {
            const response = await webinarsService.getWebinarBySlug(slug)
            return response
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

const webinarsSlice = createSlice({
    name: 'webinars',
    initialState: {
        webinars: [],
        currentWebinar: null,
        loading: false,
        hasMore: true,
        error: null
    },
    reducers: {
        clearCurrentWebinar: (state) => {
            state.currentWebinar = null
        },
        clearError: (state) => {
            state.error = null
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Webinars
            .addCase(fetchWebinars.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchWebinars.fulfilled, (state, action) => {
                state.loading = false
                const newWebinars = action.payload.data.webinars || action.payload
                if (action.payload.page > 1) {
                    state.webinars = [...state.webinars, ...newWebinars]
                } else {
                    state.webinars = newWebinars
                }
                state.hasMore = newWebinars.length === (action.payload.pagination?.limit || 10)
                state.error = null
            })
            .addCase(fetchWebinars.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            // Fetch Webinar by Slug
            .addCase(fetchWebinarBySlug.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchWebinarBySlug.fulfilled, (state, action) => {
                state.loading = false
                state.currentWebinar = action.payload.data.webinar
                state.error = null
            })
            .addCase(fetchWebinarBySlug.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
    }
})

export const { clearCurrentWebinar, clearError } = webinarsSlice.actions
export default webinarsSlice.reducer